import { useState } from "react";
import { useNavigate } from "react-router-dom";
import api, { apiError } from "@/lib/api";
import { toast } from "sonner";
import { Undo2 } from "lucide-react";
import { Modal } from "@/pages/Notizie";

export function RiportaNotizia({ im, onDone }) {
  const nav = useNavigate();
  const [open, setOpen] = useState(false);
  const [motivo, setMotivo] = useState("");
  const [err, setErr] = useState("");
  const [saving, setSaving] = useState(false);
  if (im.stato === "censito" || im.riportato_a_notizia || im._masked) return null;
  const save = async () => {
    if (!motivo.trim()) { setErr("Motivo obbligatorio"); return; }
    if (!window.confirm("Sei sicura? L'immobile torna notizia ed esce dagli incarichi attivi.")) return;
    setSaving(true);
    try {
      const r = await api.post(`/immobili/${im.id}/riporta-notizia`, { motivo: motivo.trim() });
      toast.success("Immobile riportato a notizia");
      setOpen(false);
      if (r.data.notizia_id) nav(`/notizie/${r.data.notizia_id}`); else onDone();
    } catch (e) { toast.error(apiError(e)); } finally { setSaving(false); }
  };
  return (
    <>
      <div className="flex justify-end mb-3">
        <button data-testid="riporta-notizia-btn" onClick={() => setOpen(true)} className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg border border-[var(--border)] bg-white text-xs font-semibold text-slate-600 hover:border-red-300 hover:text-red-600 transition-colors">
          <Undo2 size={13} /> Riporta a notizia
        </button>
      </div>
      {open && (
        <Modal title="Riporta a notizia" testid="riporta-notizia-modal" onClose={() => setOpen(false)} onSave={save} saving={saving} saveLabel="Riporta a notizia">
          <p className="text-sm text-slate-600 mb-3">Annulla la trasformazione in incarico fatta per errore. Venditori, documenti, foto, note e storico restano collegati; i task automatici dell'incarico vengono chiusi.</p>
          <label className="block text-[11px] font-semibold uppercase tracking-wide text-[var(--muted)] mb-1.5">Motivo *</label>
          <textarea data-testid="riporta-notizia-motivo" rows={3} value={motivo} placeholder="es. trasformato per errore" onChange={(e) => { setMotivo(e.target.value); setErr(""); }}
            className={`w-full px-3 py-2 rounded-lg border text-sm ${err ? "border-red-400" : "border-[var(--border)]"}`} />
          {err && <p data-testid="riporta-notizia-errore" className="text-xs text-red-600 mt-1">{err}</p>}
        </Modal>
      )}
    </>
  );
}
